import { withLDProvider } from 'launchdarkly-react-client-sdk';

import { makeLDContext } from './launchDarkly/LaunchDarklyContextInitializer';

export function withLaunchDarkly(WrappedComponent) {
  return withLDProvider(makeLDContext())(WrappedComponent);
}
